import { connect } from 'react-redux';
import classnames from 'classnames';
import { FormattedNumber, FormattedMessage } from 'react-intl';

import { VODCSSModules, VODBiEvents } from 'shared/utils/wix-connect';
import { canShowMainItemTitle, isCompactMainActionsOnlyIcons } from 'shared/selectors/app-settings';

import { RoundedIcon } from 'shared/components/icon/icon';
import Title from 'widget/components/player-overlay/title/title';
import ElementSwitcher from 'shared/components/element-switcher/element-switcher';

import getPlayButtonConfigForVideo from './ui-selectors/video-overlay/play/button-config';
import getPlayButtonConfigForChannel from './ui-selectors/channel-overlay/play/button-config';
import getPaidAccessButtonConfigForVideo from './ui-selectors/video-overlay/paid-access/button-config';
import getPaidAccessButtonConfigForChannel from './ui-selectors/channel-overlay/paid-access/button-config';

import styles from './overlay.styl';


const SIZE_FOR_SHOWING_FULL_BUTTONS = 401;


class Overlay extends React.Component {

  static displayName = 'Overlay';

  static propTypes = {
    className: React.PropTypes.string,
    channelData: React.PropTypes.object,
    videoItem: React.PropTypes.object,
    appSettings: React.PropTypes.object.isRequired,

    canShowMainItemTitle: React.PropTypes.bool,
    isMainActionsOnlyIcons: React.PropTypes.bool,

    playButtonConfig: React.PropTypes.object,
    paidAccessButtonConfig: React.PropTypes.object,

    onPlayRequest: React.PropTypes.func,
    onPlayMemberOnlyRequest: React.PropTypes.func,
    onPlayWithoutPreviewRequest: React.PropTypes.func,
    onSubscriptionRequest: React.PropTypes.func,
    onPurchaseRequest: React.PropTypes.func,
  };

  static defaultProps = {
    showChannelCover: false,
    onPlayRequest: _.noop,
    onPlayMemberOnlyRequest: _.noop,
    onPlayWithoutPreviewRequest: _.noop,
    onPurchaseRequest: _.noop,
    onSubscriptionRequest: _.noop,
  };

  get clampOptions() {
    return { lineClamp: 2 };
  }

  get shouldShowTitle() {
    return this.props.canShowMainItemTitle;
  }

  get title() {
    if (!this.shouldShowTitle) {
      return null;
    }

    const titleText = this.titleText;

    if (!titleText) {
      return null;
    }

    return (
      <Title styleName="title"
             className="qa-widget-overlay-title"
             text={titleText}
             clampOptions={this.clampOptions} />
    );
  }

  renderPlayButton(isSmallView) {
    const { playButtonConfig, isMainActionsOnlyIcons } = this.props;

    if (!playButtonConfig) {
      return null;
    }

    const { translationData, callback } = playButtonConfig;

    const styleNames = classnames('button', {
      'play-button': true,
      'only-icon': isMainActionsOnlyIcons,
    });

    return (
      <a href=""
         styleName={styleNames}
         onClick={callback}
         className="qa-widget-overlay-play-button">
        <RoundedIcon styleName="icon play-icon"
                     name="arrow-right-filled" />
        {!isMainActionsOnlyIcons && !isSmallView && (
          <span styleName="text">
            <FormattedMessage {...translationData.props} />
          </span>
        )}
      </a>
    );
  }

  renderPaidAccessButton(isSmallView) {
    const { isMainActionsOnlyIcons, paidAccessButtonConfig } = this.props;

    if (!paidAccessButtonConfig) {
      return null;
    }

    const { callback, translationData } = paidAccessButtonConfig;
    const { priceModel: { price, currency } } = translationData;

    const values = {
      price: <FormattedNumber value={price}
                              style="currency"
                              currency={currency} />,
    };

    const styleNames = classnames('button', 'paid-access-button', {
      'paid-access-button': true,
      'only-icon': isMainActionsOnlyIcons,
    });

    return (
      <a href=""
         styleName={styleNames}
         onClick={callback}
         className="qa-widget-overlay-buy-from-button">
        {(isMainActionsOnlyIcons || isSmallView) && (
          <RoundedIcon styleName="icon paid-icon"
                       name="paid" />
        )}
        {!isMainActionsOnlyIcons && !isSmallView && (
          <span styleName="text">
            <FormattedMessage {...translationData.props}
                              values={values} />
          </span>
        )}
      </a>
    );
  }

  get normalButtons() {
    const play = this.renderPlayButton();
    const purchase = this.renderPaidAccessButton();

    return (
      <div styleName="buttons-wrapper">
        {play}
        {purchase}
      </div>
    );
  }

  get smallButtons() {
    const play = this.renderPlayButton(true);
    const purchase = this.renderPaidAccessButton(true);

    return (
      <section styleName="buttons-wrapper">
        {play}
        {purchase}
      </section>
    );
  }

  render() {
    const {
      channelData,
      videoItem,
      className,
    } = this.props;

    if (!channelData || !videoItem) {
      return null;
    }

    return (
      <div styleName="overlay-wrapper"
           className={className}>
        <div styleName="background" />
        <div styleName="content">
          <div styleName="top-content"
               dir="ltr">
            <div styleName="title-block">
              {this.title}
            </div>
            <ElementSwitcher shouldAlwaysMeasure
                             maxWidth={SIZE_FOR_SHOWING_FULL_BUTTONS}>
              {this.normalButtons}
              {this.smallButtons}
            </ElementSwitcher>
          </div>
        </div>
      </div>
    );
  }
}

@connect((state, ownProps) => ({
  playButtonConfig: getPlayButtonConfigForVideo(ownProps),
  paidAccessButtonConfig: getPaidAccessButtonConfigForVideo(ownProps),
  canShowMainItemTitle: canShowMainItemTitle(state),
  isMainActionsOnlyIcons: isCompactMainActionsOnlyIcons(state),
}))
@VODBiEvents()
@VODCSSModules(styles)
export class VideoOverlay extends Overlay {
  get titleText() {
    const { videoItem } = this.props;

    return videoItem.title;
  }
}

@connect((state, ownProps) => ({
  playButtonConfig: getPlayButtonConfigForChannel(ownProps),
  paidAccessButtonConfig: getPaidAccessButtonConfigForChannel(ownProps),
  canShowMainItemTitle: canShowMainItemTitle(state),
  isMainActionsOnlyIcons: isCompactMainActionsOnlyIcons(state),
}))
@VODBiEvents()
@VODCSSModules(styles)
export class ChannelOverlay extends Overlay {
  get titleText() {
    const { channelData } = this.props;

    return channelData.title;
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/player-overlay/overlay.js